import React from "react";
import FormField from "./FormField";
import renderIf from "../../utils/renderIf";
import { MAX_INPUT_LENGTH } from "../../config";

const Form = ({
  fieldsStructure,
  fields,
  showErrors,
  handleFieldChange,
  yardProps,
  valueObj
}) => {
  const form = fieldsStructure.map(field => {
    let value = valueObj
      ? valueObj[field.name]
      : fields[field.name]
        ? fields[field.name].value
        : "";
    return renderIf(fields[field.name] ? fields[field.name].readable : true)(
      <FormField
        label={field.label}
        dataSource={field.dataSource ? field.dataSource : []}
        key={field.name}
        name={field.name}
        type={field.type}
        editable={
          fields[field.name] ? fields[field.name].editable : field.editable
        }
        required={
          fields[field.name] ? fields[field.name].required : field.required
        }
        value={value}
        onChanged={handleFieldChange}
        showError={showErrors ? showErrors : false}
        regEx={field.regEx}
        maxLength={field.maxLength ? field.maxLength : MAX_INPUT_LENGTH}
        multiline={field.multiline ? field.multiline : false}
        transform={field.transform ? field.transform : x => x}
        yardProps={yardProps}
        helpText={field.helpText}
        questionLabel={field.questionLabel}
        positionHelpText={field.positionHelpText}
      />
    );
  });
  return form ? <div>{form}</div> : <div />;
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/form/Form.js